/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getDealerLocationsAsync } from './DataActionExtension.g';
// import { IDealerLocationEntity } from './DataServiceEntities.g';
import { IFullOrgUnitAvailability } from '@msdyn365-commerce-modules/retail-actions';

/**
 * GetManufacturerCodes Input Action
 */
export class GetDealerLocationsInput implements Msdyn365.IActionInput {
    public useChannelMfr: boolean;
    public latitude: number;
    public longitude: number;
    public distanceInMiles: number;
    constructor(useChannelMfr: boolean, latitude: number, longitude: number, distanceInMiles: number) {
        this.useChannelMfr = useChannelMfr;
        this.latitude = latitude;
        this.longitude = longitude;
        this.distanceInMiles = distanceInMiles;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `DealerLocations-${this.latitude.toFixed(5)}-${this.longitude.toFixed(5)}`;
    public getCacheObjectType = () => 'DealerLocations';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetDealerLocationsData {
    dealerLocations: IFullOrgUnitAvailability[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createDealerLocationsInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    // @ts-expect-error
    const useChannelMfr = args.config?.useChannelMfr;
    // @ts-expect-error
    const defaultLat = args.config?.defaultLatitudeValue || 39.8283;
    // @ts-expect-error
    const defaultLon = args.config?.defaultLongitudeValue || -98.5795;
    const lat = args.requestContext.query?.latitude;
    const latitude = lat ? parseFloat(lat) : defaultLat;
    const lon = args.requestContext.query?.longitude;
    const longitude = lon ? parseFloat(lon) : defaultLon;
    // @ts-expect-error
    const distanceInMiles = args.config?.lookupRadius;
    return new GetDealerLocationsInput(useChannelMfr, latitude, longitude, distanceInMiles);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetDealerLocationsInput, ctx: Msdyn365.IActionContext): Promise<IFullOrgUnitAvailability[]> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    const response = await getDealerLocationsAsync(
        { callerContext: ctx },
        input.useChannelMfr,
        input.latitude,
        input.longitude,
        input.distanceInMiles
    );
    const dealerLocations: IFullOrgUnitAvailability[] = response.map(dealer => {
        return {
            OrgUnitLocation: {
                OrgUnitName: dealer.Name,
                OrgUnitNumber: dealer.CustomerNumber,
                Latitude: dealer.Latitude,
                Longitude: dealer.Longitude,
                Address: dealer.Address,
                ChannelId: dealer.RecId,
                Distance: dealer.Distance
            },
            OrgUnitAvailability: {
                OrgUnitLocation: {
                    OrgUnitName: dealer.Name,
                    OrgUnitNumber: dealer.CustomerNumber,
                    Latitude: dealer.Latitude,
                    Longitude: dealer.Longitude,
                    Address: dealer.Address,
                    ChannelId: dealer.RecId,
                    Distance: dealer.Distance
                }
            }
        };
    });
    return dealerLocations;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IFullOrgUnitAvailability[]>>action,
    // TODO: Give your data action a unique id
    id: 'GetDealerLocations',
    input: createDealerLocationsInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
